import { delay, HttpResponse } from 'msw';

import { mockSuppressedListSelectOperationQuery } from 'core/graphql';

export const TEST_SUPPRESSED_LIST_SELECT_NAME = 'testSuppressedList';

export const handlers = [
  mockSuppressedListSelectOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          suppressLists: {
            __typename: 'SuppressListPage',
            total: 1,
            objects: [
              {
                __typename: 'SuppressList',
                id: '1',
                name: TEST_SUPPRESSED_LIST_SELECT_NAME,
              },
            ],
          },
        },
      });
    }
  ),
];
